import {
    CLEAR_APP_STATE, CLEAR_STATE,
    GET_ALL_PAYMENT_PROVIDERS_SUCCESS,
    SAVE_TRANSACTION_ID,
    MOLLIE_RESPONSE_STATUS,
    AUTHIPAY_RESPONSE_STATUS,
    AUTHIPAY_DATA,
    CLICK_APPLE_GOOGLE_PAY,
    BAMBORA_DATA,
    CLEAR_BAMBORA_DATA,
    STRIPE_HOSTED_PAYMENT_DATA,
    CLEAR_STRIPE_HOSTED_PAYMENT_DATA,
    WORLDPAY_DATA,
    CLEAR_WORLDPAY_DATA,
    MONERIS_DATA,
    CLEAR_MONERIS_DATA,
    RYFT_DATA,
    CLEAR_RYFT_DATA,
    CLEAR_TBK_DATA,
    TBK_USER_DATA,
    CONFIRM_ENROLLMENT_ERR_MSG
} from '../../../actions/types';

const INITIAL_STATE = {
    providerType: {},
    stripePremenuData: {}, // if Stripe
    monerisPremenuData: {},
    mollieTransactionId: null,
    molliePaymentStatus: null,
    authipayPaymentStatus: null,
    authipayData: {
        cardId: null,
        hash: null,
        orderId: null,
        storeId: null,
        textDate: null,
        timeZone: null
    },
    bamboraData: null,
    stripeHostedPaymentData: null,
    worldPayData: {
        verificationCode: null,
        redirectUrl: null
    },
    monerisData: null,
    ryftData: null,
    isAppleGooglePayClicked: false,
    tbkUser: null,
    confirmEnrollmentErrMsg: null
};

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_PAYMENT_PROVIDERS_SUCCESS:
            return {
                ...state,
                providerType: payload.providerType,
                stripePremenuData: payload.stripePremenuData,
                monerisPremenuData: payload.monerisPremenuData
            };
        case SAVE_TRANSACTION_ID:
            return {
                ...state,
                mollieTransactionId: payload
            };
        case MOLLIE_RESPONSE_STATUS:
            return {
                ...state,
                molliePaymentStatus: payload
            };
        case AUTHIPAY_DATA:
            return {
                ...state,
                authipayData: payload
            };
        case AUTHIPAY_RESPONSE_STATUS:
            return {
                ...state,
                authipayPaymentStatus: payload
            };
        case BAMBORA_DATA:
            return {
                ...state,
                bamboraData: payload
            };
        case CLEAR_BAMBORA_DATA:
            return {
                ...state,
                bamboraData: null
            };
        case STRIPE_HOSTED_PAYMENT_DATA:
            return {
                ...state,
                stripeHostedPaymentData: payload
            };
        case CLEAR_STRIPE_HOSTED_PAYMENT_DATA:
            return {
                ...state,
                stripeHostedPaymentData: null
            };
        case MONERIS_DATA:
            return {
                ...state,
                monerisData: payload
            }
        case CLEAR_MONERIS_DATA:
            return {
                ...state,
                monerisData: null
            }
        case RYFT_DATA:
            return {
                ...state,
                ryftData: payload
            }
        case CLEAR_RYFT_DATA:
            return {
                ...state,
                ryftData: null
            }
        case CLICK_APPLE_GOOGLE_PAY:
            return {
                ...state,
                isAppleGooglePayClicked: !state.isAppleGooglePayClicked
            }
        case WORLDPAY_DATA:
            return {
                ...state,
                worldPayData: payload
            };
        case CLEAR_WORLDPAY_DATA:
            return {
                ...state,
                worldPayData: {
                    verificationCode: null,
                    redirectUrl: null
                }
            };
        case CLEAR_TBK_DATA:
            return {
                ...state,
                tbkUser: null
            };
        case TBK_USER_DATA:
            return {
                ...state,
                tbkUser: payload
            };
        case CONFIRM_ENROLLMENT_ERR_MSG:
            return {
                ...state,
                confirmEnrollmentErrMsg: payload
            }
        case CLEAR_APP_STATE:
        case CLEAR_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
}